import { dataFix } from "../../../global/common/dataFix"
import { callFunction } from "../../../global/functions/fbAll"

const golfGenericTypes = {
  golfGeneric: 'golfGeneric',
}

export const golfFunctionTypes = {
  createGolfMatches: 'createGolfMatches',
  createGolfRoundMatches: 'createGolfRoundMatches',
  createGolfRoundMatchesPreview: 'createGolfRoundMatchesPreview',
  createGolfTournament: 'createGolfTournament',
  createGolfTournamentRounds: 'createGolfTournamentRounds',
  settingsGolf: 'settingsGolf',
  updateGolfRoundMatches: 'updateGolfRoundMatches',
}

const callFsFunction = async (fsCall, callData) => {
  const data = await fsCall(golfGenericTypes.golfGeneric, callData)
  return data
}

export const fsfn_allGolf = (fsCall) => {
  return {
    createGolfMatches: (eventTeams, roundLineups, totalMatches) => fsfn_createGolfMatches(fsCall, eventTeams, roundLineups, totalMatches),
    createGolfRoundMatches: (paps_state, golfRoundKey, matches, callback) => fsfn_createGolfRoundMatches(fsCall, paps_state, golfRoundKey, matches, callback),
    createGolfTournament: (pathViews, ufPropsAdd, tournamentDetails, teams_event, previewOnly) => fsfn_createGolfTournament(fsCall, pathViews, ufPropsAdd, tournamentDetails, teams_event, previewOnly),
    createGolfRoundMatchesPreview: (tournamentDetails, golfRoundKey) => fsfn_createGolfRoundMatchesPreview(fsCall, tournamentDetails, golfRoundKey),
    createGolfTournamentRounds: (paps_state) => fsfn_createGolfTournamentRounds(fsCall, paps_state),
    settingsGolf: (vvProps) => fsfn_settingsGolf(fsCall, vvProps),
    updateGolfRoundMatches: (paps_state, matches, callback) => fsfn_updateGolfRoundMatches(fsCall, paps_state, matches, callback),
  }
}

const fsfn_createGolfMatches = async (fsCall, eventTeams, roundLineups, totalMatches) => {
  const callData = { golfFunctionType: golfFunctionTypes.createGolfMatches, eventTeams, roundLineups, totalMatches }
  try {
    const response_data = await callFsFunction(fsCall, callData)
    return response_data
  } catch (error) {
    console.error(error)
  }
}

// paps_state, golfRoundKey, matches, handleDone
const fsfn_createGolfRoundMatches = async (fsCall, paps_state, golfRoundKey, matches, callback) => {
  const callData = { golfFunctionType: golfFunctionTypes.createGolfRoundMatches, paps_state, golfRoundKey, matches }
  try {
    const response_data = await callFsFunction(fsCall, callData)
    callback(matches)
    return response_data
  } catch (error) {
    console.error(error)
  }
}

const fsfn_createGolfTournament = async (fsCall, pathViews, ufPropsAdd, tournamentDetails, teams_event, previewOnly) => {
  const callData = { golfFunctionType: golfFunctionTypes.createGolfTournament, pathViews, ufPropsAdd, tournamentDetails, teams_event, previewOnly, showLogs: true }
  try {
    const response_data = await callFsFunction(fsCall, callData)
    return response_data
  } catch (error) {
    console.error(error)
  }
}

const fsfn_createGolfRoundMatchesPreview = async (fsCall, tournamentDetails, golfRoundKey) => {
  const d = dataFix.removeEmpties(tournamentDetails)
  const callData = { golfFunctionType: golfFunctionTypes.createGolfRoundMatchesPreview, tournamentDetails: d, golfRoundKey, showLogs: true }
  try {
    const response_data = await callFsFunction(callData)
    return response_data
  } catch (error) {
    console.error(error)
  }
}

const fsfn_createGolfTournamentRounds = async (fsCall, paps_state) => {
  const callData = { golfFunctionType: golfFunctionTypes.createGolfTournamentRounds, paps_state }
  try {
    const response_data = await callFsFunction(fsCall, callData)
    return response_data
  } catch (error) {
    console.error(error)
  }
}

const fsfn_settingsGolf = async (fsCall, vvProps) => {
  const callData = { golfFunctionType: golfFunctionTypes.settingsGolf, vvProps }
  try {
    const response_data = await callFsFunction(fsCall, callData)
    console.log('response_data', response_data)
    return response_data
  } catch (error) {
    console.error(error)
  }
}

const fsfn_updateGolfRoundMatches = async (fsCall, paps_state, matches, callback) => {
  const callData = { golfFunctionType: golfFunctionTypes.updateGolfRoundMatches, paps_state, matches }
  try {
    const response_data = await callFsFunction(fsCall, callData)
    const { matches } = response_data ?? {}
    callback(matches)
    return response_data
  } catch (error) {
    console.error(error)
  }
}